/**
 * PATH: src/pages/pricing/components/InvoiceList.jsx
 * PURPOSE: Display the list of past transactions (payment history)
 * UI: Material UI
 */

import React from "react";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Paper,
} from "@mui/material";

export default function InvoiceList({ invoices = [] }) {
  if (!invoices.length) {
    return (
      <Typography color="text.secondary" mt={2}>
        No transactions available.
      </Typography>
    );
  }

  return (
    <TableContainer component={Paper} elevation={2} sx={{ borderRadius: 2 }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell><strong>Date</strong></TableCell>
            <TableCell><strong>Type</strong></TableCell>
            <TableCell><strong>Amount</strong></TableCell>
            <TableCell><strong>Status</strong></TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {invoices.map((tx) => (
            <TableRow key={tx._id}>
              <TableCell>{tx.createdAt?.slice(0, 10)}</TableCell>

              <TableCell>
                {tx.revenueStream === "training"
                  ? "Training Purchase"
                  : tx.type === "subscription"
                  ? "Subscription"
                  : "Payment"}
              </TableCell>

              <TableCell>₹{(tx.amountCents / 100).toFixed(2)}</TableCell>

              <TableCell>
                <Chip
                  label={tx.status}
                  size="small"
                  color={
                    tx.status === "success"
                      ? "success"
                      : tx.status === "failed"
                      ? "error"
                      : "warning"
                  }
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
